import { render, staticRenderFns } from "./asset-type-attributes.vue?vue&type=template&id=05f7f5c3&scoped=true&"
import script from "./asset-type-attributes.vue?vue&type=script&lang=js&"
export * from "./asset-type-attributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f7f5c3",
  null
  
)

export default component.exports